import { render, staticRenderFns } from "./CardPeople1.vue?vue&type=template&id=f8bc2ab6"
import script from "./CardPeople1.vue?vue&type=script&lang=js"
export * from "./CardPeople1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports